
import React, { useEffect, useState, useContext } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { PlusCircle } from "react-feather";
// import Select from 'react-select';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Table,Modal, Select  } from "antd";
import AddHolidays from "../../core/modals/hrm/addholidays.jsx";
import EditHolidays from "../../core/modals/hrm/editholidays.jsx";
import { getAllHolidays, deleteHoliday } from "../../service/holidayService.js";

//import dayjs from 'dayjs';
import { ArrowLeft } from "lucide-react";
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";  


const Holidays = () => {
  const { user } = useContext(UserContext);
  const [dataSource, setDataSource] = useState([]);
  const [shouldReloadData, setShouldReloadData] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 })
    const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false)
    const [tempPageSize, setTempPageSize] = useState(pagination.pageSize)
    const pageSizeOptions = [5, 10, 20, 50, 100]

  const handleReloadData = () => {
    setShouldReloadData(!shouldReloadData);
  };
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
  };
  const handleTableChange = (pagination) => {
    setPagination(pagination)
  }

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 }
    setPagination(newPagination)
    setPageSizeModalVisible(false)
  }
  // const oldandlatestvalue = [
  //     { value: 'date', label: 'Sort by Date' },
  //     { value: 'newest', label: 'Newest' },
  //     { value: 'oldest', label: 'Oldest' },
  // ];
  //const search="";
  const fetchHolidays = async (search = "") => {
    setLoading(true);
    await getAllHolidays({
      search,
      setData: setDataSource,
    });
    setLoading(false);
  };


  //const hasJobRightWithdown = userRightssub.some(right => right.right === 'Holidays' && right.fdownload=== 1);

  useEffect(() => {
    fetchHolidays(search);
  }, [shouldReloadData, search]);

  console.log(dataSource);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      sorter: (a, b) => a.date.length - b.date.length,
      render: (date) => moment(date).format("DD-MM-YYYY"),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      sorter: (a, b) => a.date.length - b.date.length,
      render: (date) => moment(date).format("DD-MM-YYYY"),
    },
    {
      title: "Duration",
      dataIndex: "duration",
      sorter: (a, b) => a.duration.length - b.duration.length,
    },
    {
      title: "Created On",
      dataIndex: "createdAt",
      sorter: (a, b) => a.createdon.length - b.createdon.length,
      render: (date) => moment(date).format("DD-MM-YYYY"),
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <span
          className={`badge ${
            status ? "badge-linesuccess" : "badge-linedanger"
          }`}
          style={{ width: 80, padding: 6 }}
        >
          <Link to="#" style={{ cursor: "default", fontSize: 14 }}>
            {status ? "Active" : "Inactive"}
          </Link>
        </span>
      ),
      sorter: (a, b) => a.status.length - b.status.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <td className="action-table-data">

            <Link
            className={`me-2 p-2 ${
              user?.permissions && hasPermission(user.permissions,"HRM", "Holidays", "edit")
                ? '' 
                : 'disabled'
            }`}
            to="#"
              data-bs-toggle="modal"
              data-bs-target="#edit-department"
              onClick={() => {
                if (user?.permissions && hasPermission(user.permissions,"HRM", "Holidays", "edit")) {handleEditClick(record._id);
              }
            }}
            title={
              !(user?.permissions && hasPermission(user.permissions,  "HRM", "Holidays", "edit"))
                ? "You don't have permission to edits"
                : "Edit Holidays"
            }>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>



        <Link 
          className={`confirm-text p-2 ${
            user?.permissions && 
            hasPermission(user.permissions, "HRM", "Holidays", "delete")
              ? '' 
              : 'disabled'
          }`}
          to="#"
          onClick={() => {
            if (user?.permissions &&
                hasPermission(user.permissions, "HRM", "Holidays", "delete")) {
              showConfirmationAlert(record._id);
            }
          }}
          title={
            (user?.permissions &&
              hasPermission(user.permissions,  "HRM", "Holidays", "delete"))
              ? "You don't have permission to delete holidays"
              : "Delete holiday"
          }
        >
          <i data-feather="trash-2" className="feather-trash-2"></i>
        </Link>

    </td>
      ),
    },
  ];
  const MySwal = withReactContent(Swal);
  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteHoliday({ id });
        handleReloadData();
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const handleEditClick = (id) => {
    setSelectedId(id);
  };

  // const isStartDateBeforeCurrentMonth = (startDate) => {
  //     return dayjs(startDate).isBefore(dayjs().startOf('month'), 'month');
  // };

  return (
    <div>
      <div className="page-wrapper-lt">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="header-leave-container ">
                <div>
                  <ArrowLeft size={32} />
                </div>

                <div className="page-title">
                  <h4>Holidays</h4>
                  <h6>Manage your holidays</h6>
                </div>
              </div>
              <div className="page-btn">
  <Link
    to=""
    className={`btn btn-added ${
      user?.permissions && hasPermission(user.permissions, "HRM",  "Holidays", "create")
        ? '' 
        : 'disabled'
    }`}
    data-bs-toggle={
      user?.permissions && hasPermission(user.permissions, "HRM",  "Holidays", "create")
        ? "modal"
        : undefined
    }
    data-bs-target={
      user?.permissions && hasPermission(user.permissions, "HRM",  "Holidays", "create")
        ? "#add-department"
        : undefined
    }
    title={
      user?.permissions && hasPermission(user.permissions, "HRM",  "Holidays", "create")
        ? "You don't have permission to add holidays"
        : "Add new holiday"
    }
  >
    <PlusCircle className="me-2" />
    Add New
  </Link>
</div>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card-grid">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="search"
                      placeholder="Search"
                      className="form-control"
                      value={search}
                      onChange={handleSearch}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                  <div className="wordset">
                  <style>
    {`
      @media (max-width: 767px) {
        .wordset {
          margin-bottom: 25px !important;
        }
      }
    `}
  </style>
                    <ul>
                      {/* <li>
                                            <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="pdf">
                                               <img src="assets/img/icons/pdf.svg" alt="pdf" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="excel">
                                               <img src="assets/img/icons/excel.svg" alt="excel" />
                                            </a>
                                        </li> */}

                    </ul>
                  </div>
                </div>
                <div className="search-path d-flex align-items-center search-path-new">
                  <div className={`layout-hide-box`}></div>
                </div>
                {/* <div className="search-set">
                  <a href="#" className="btn btn-filter" id="filter_search">
                    <Sliders className="me-2" />
                    Filter
                  </a>
                </div> */}
              </div>

              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={dataSource}
                  pagination={{
                    current: pagination.current,
                    total: dataSource.length,
                    pageSizeOptions: ["5", "10", "20", "50"],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `Total ${total} items`
                  }}
                  onChange={handleTableChange}
                  // footer={() => (
                  //   <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  //     <button className="btn btn-primary btn-sm" onClick={() => setPageSizeModalVisible(true)}>
                  //       Change Page Size
                  //     </button>
                  //   </div>
                  // )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddHolidays onHolidayAdded={handleReloadData} />
      <EditHolidays onHolidayAdded={handleReloadData} holidayId={selectedId} />
            <Modal
              title="Change Page Size"
              open={pageSizeModalVisible}
              onOk={handlePageSizeChange}
              onCancel={() => setPageSizeModalVisible(false)}
              footer={[
                <button key="cancel" className="btn btn-cancel" onClick={() => setPageSizeModalVisible(false)}>
                  Cancel
                </button>,
                <button key="submit" className="btn btn-submit" onClick={handlePageSizeChange}>
                  Apply
                </button>,
              ]}
            >
              <div className="form-group">
                <label>Items per page:</label>
                <Select style={{ width: "100%" }} value={tempPageSize} onChange={(value) => setTempPageSize(value)}>
                  {pageSizeOptions.map((size) => (
                    <Select.Option key={size} value={size}>
                      {size}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </Modal>
    </div>
  );
};

export default Holidays;
